import React from 'react';
import { IMask } from 'react-imask';

function PhoneValue({ phoneValue, setPhoneValue, style }) {
    const formatPhone = (event) => {
        const value = event.currentTarget.value;
        const mask = IMask.createMask({
            mask: '+7 (000)000-00-00',
        });
        mask.resolve(value);
        setPhoneValue(mask.value);
    };

    return (
        <input
            onChange={(event) => formatPhone(event)}
            type="tel"
            value={phoneValue}
            style={phone}
            maxLength={17}
            placeholder="Введите номер телефона"
        />
    );
}

const phone = {
    display: 'flex',
    height: '3.75rem',
    padding: '0.625rem 1rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '0.5rem',
    background: 'var(--Colors-plashka_parametr, rgba(116, 116, 128, 0.08))',
    color: '#8a8a8e',
    overflow: 'hidden',
    fontFamily: "'Inter', sans-serif",
    fontFeatureSettings: '"case" on',
    textOverflow: 'ellipsis',
    fontSize: '1.1rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1.5rem',
};

export default PhoneValue;
